import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Select, DatePicker } from 'antd';
import DrawerModal from '../../shared/DrawerModal';
import styles from './EditIDModal.styles';
import { closeModal, getIsVisibleModal } from '../../../redux/store/ui/common';
import {
  addUserID,
  selectSelectedUser,
} from '../../../redux/store/userData/users';
import { useIntl } from 'react-intl';
import { zIndex } from '../../../theme/theme';
import { ANT_PICKERS_FORMAT, formatAPIDate } from '../../../utils';
import dayjs from 'dayjs';
import { selectAdminBrands } from '../../../redux/store/userData/user';

const { Option } = Select;

export const MODAL_ADD_USER_ID = 'AddIDModal';
const AddIDModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectSelectedUser);
  const visibleModal = useSelector(getIsVisibleModal(MODAL_ADD_USER_ID));
  const adminBrands = useSelector(selectAdminBrands);

  const selectedUserBrand = adminBrands?.filter(
    (brand) => brand.id === selectedUser?.brandId
  );

  const supportedIdentityCountries =
    selectedUserBrand[0]?.allowedIDDocumentCountries?.map((country) =>
      country.toUpperCase()
    );

  const [type, setType] = useState('');
  const [number, setNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [expiryDate, setExpiryDate] = useState('') as any;
  const [dateOfBirth, setDateOfBirth] = useState('') as any;
  const [issueDate, setIssueDate] = useState('') as any;
  const [issuePlace, setIssuePlace] = useState('');
  const [birthPlace, setBirthPlace] = useState('');
  const [issueCountry, setIssueCountry] = useState('DE');

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(
      addUserID(selectedUser.id, {
        status: 'verified',
        documentType: type,
        number,
        firstName,
        lastName,
        issuePlace,
        birthPlace,
        issueCountry,
        issueDate: formatAPIDate(issueDate),
        expiryDate: formatAPIDate(expiryDate),
        dateOfBirth: formatAPIDate(dateOfBirth),
      })
    );
    dispatch(closeModal(MODAL_ADD_USER_ID));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal(MODAL_ADD_USER_ID));
  };

  useEffect(() => {
    if (visibleModal) {
      setNumber('');
      setFirstName('');
      setLastName('');
      setType('');
      setIssueDate('');
      setExpiryDate('');
      setDateOfBirth('');
      setIssuePlace('');
      setBirthPlace('');
      setIssueCountry('DE');
    }
  }, [visibleModal]);

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('UserContactModal'));
        }}
      >
        <div className="update-phone-modal">
          <div className="phone-modal-wrapper">
            <div className="update-phone-modal-inputs">
              <p
                data-testid="AddIDModal-modalTitle"
                className="add-phone-title"
              >
                {intl.formatMessage({
                  id: `fleetadmin.users.info.id.manualForm.add.title`,
                })}
              </p>
              <div className="id">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.type`,
                  })}
                </p>
                <Select
                  data-testid="AddIDModal-docTypeSelector"
                  dropdownStyle={{ zIndex: zIndex.dropDown }}
                  value={type || undefined}
                  style={{ width: '100%' }}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.type`,
                  })}
                  onChange={(value: string) => {
                    setType(value);
                  }}
                >
                  {['ID_CARD', 'PASSPORT', 'VISA'].map((docType) => (
                    <Option
                      data-testid={`AddIDModal-docTypeOption-${docType}`}
                      key={docType}
                      value={docType}
                    >
                      {intl.formatMessage({
                        id: `${docType}`,
                      })}
                    </Option>
                  ))}
                </Select>
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.number`,
                  })}
                </p>
                <Input
                  data-testid="AddIDModal-numberInput"
                  value={number}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.number`,
                  })}
                  onChange={(e: any) => {
                    setNumber(e.target.value);
                  }}
                />
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.firstName`,
                  })}
                </p>
                <Input
                  data-testid="AddIDModal-firstNameInput"
                  value={firstName}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.firstName`,
                  })}
                  onChange={(e: any) => {
                    setFirstName(e.target.value);
                  }}
                />
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.lastName`,
                  })}
                </p>
                <Input
                  data-testid="AddIDModal-lastNameInput"
                  value={lastName}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.lastName`,
                  })}
                  onChange={(e: any) => {
                    setLastName(e.target.value);
                  }}
                />
              </div>
              <div className="id">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.birthPlace`,
                  })}
                </p>
                <Input
                  data-testid="AddIDModal-birthPlaceInput"
                  value={birthPlace}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.birthPlace`,
                  })}
                  onChange={(e: any) => {
                    setBirthPlace(e.target.value);
                  }}
                />
              </div>
              <div className="id-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.dateOfBirth`,
                  })}
                </p>
                <DatePicker
                  data-testid="AddIDModal-birthDateInput"
                  format={ANT_PICKERS_FORMAT}
                  getPopupContainer={(triggerNode: HTMLElement) => {
                    return triggerNode.parentNode as HTMLElement;
                  }}
                  style={{ width: '100%' }}
                  value={dateOfBirth ? dayjs(dateOfBirth) : undefined}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.dateOfBirth`,
                  })}
                  onChange={(date) => setDateOfBirth(date?.toISOString())}
                />
              </div>
              <div className="id-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.issuePlace`,
                  })}
                </p>
                <Input
                  data-testid="AddIDModal-issuePlaceInput"
                  value={issuePlace}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.issuePlace`,
                  })}
                  onChange={(e: any) => {
                    setIssuePlace(e.target.value);
                  }}
                />
              </div>
              <div className="id-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.issueDate`,
                  })}
                </p>
                <DatePicker
                  data-testid="AddIDModal-issueDateInput"
                  format={ANT_PICKERS_FORMAT}
                  getPopupContainer={(triggerNode: HTMLElement) => {
                    return triggerNode.parentNode as HTMLElement;
                  }}
                  style={{ width: '100%' }}
                  value={issueDate ? dayjs(issueDate) : undefined}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.issueDate`,
                  })}
                  onChange={(date) => setIssueDate(date?.toISOString())}
                />
              </div>
              <div className="id-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.expiryDate`,
                  })}
                </p>
                <DatePicker
                  data-testid="AddIDModal-expiryDateInput"
                  format={ANT_PICKERS_FORMAT}
                  getPopupContainer={(triggerNode: HTMLElement) => {
                    return triggerNode.parentNode as HTMLElement;
                  }}
                  style={{ width: '100%' }}
                  value={expiryDate ? dayjs(expiryDate) : undefined}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.id.manualForm.expiryDate`,
                  })}
                  onChange={(date) => setExpiryDate(date?.toISOString())}
                />
              </div>

              <p className="label">
                {intl.formatMessage({
                  id: `fleetadmin.users.info.id.manualForm.issueCountry`,
                })}
              </p>
              <Select
                data-testid="AddIDModal-issueCountrySelector"
                dropdownStyle={{ zIndex: zIndex.dropDown }}
                value={issueCountry}
                style={{ width: '100%' }}
                placeholder={intl.formatMessage({
                  id: `fleetadmin.users.info.id.manualForm.issueCountry`,
                })}
                onChange={(code: string) => setIssueCountry(code)}
              >
                {supportedIdentityCountries?.map((country) => (
                  <Option
                    data-testid={`AddIDModal-countryOption-${country}`}
                    key={`${country}`}
                    value={country}
                  >
                    {intl.formatMessage({
                      id: `${country}`,
                    })}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <Button
            data-testid="AddIDModal-modalSubmitBtn"
            disabled={!(number && issueCountry && issueDate && expiryDate)}
            className="submit-button"
            onClick={handleOnSubmit}
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default AddIDModal;
